module.exports = __webpack_public_path__ + "static/media/ProximaNovaACond-Semibold.58749c25.woff";